import React from 'react';
import EditableTextCellEditor from './EditableTextCellEditor';

const trim = inputChangeValue => inputChangeValue.trim();

const LinkCellEditor = props => <EditableTextCellEditor {...props} parseInputValue={trim} />;

export default LinkCellEditor;
